import React, { useState, useEffect } from 'react';
import '../../styles/DefaultDashboard.css';
import { getAllEnrolledStudent, getDashboardSummary } from '../../services/getAdminApi';
import { Link } from 'react-router-dom';
import { DonutChart, LineChart } from '../index';

const DefaultDashboard = () => {
  const [summaryData, setSummaryData] = useState(null);
  const [enrolledStudents, setEnrolledStudents] = useState([]);  // State to store enrolled students data

  useEffect(() => {
    const fetchDashboardSummary = async () => {
      try {
        const res = await getDashboardSummary();
        const enrollRes = await getAllEnrolledStudent();  

       
        setSummaryData(res.data);
        setEnrolledStudents(enrollRes.data.data);
     

      } catch (error) {
        console.error("Error fetching dashboard summary: ", error);
      }
    };

    fetchDashboardSummary();
  }, []);

  return (
    <>
      {/* Three Insights Tab Section */}
      <div>
        <div className="dashboard-heading-div">
          <p>Admin Dashboard</p>
        </div>
        <div>
          <div className="insights">
            <div className="sales">
              <span className="material-symbols-outlined">trending_up</span>
              <div className="middle">
                <div className="left">
                  <h3>Total Enquires</h3>
                  <h1>{summaryData && summaryData.total_enquiries ? summaryData.total_enquiries : "Loading"}</h1>
                </div>
                <div className="dashboard-insights-progress">
                  <Link to='/dashboard/enquiry'>
                    <p className="material-symbols-outlined view-all-dashboard-icon">
                      table_view
                    </p>
                  </Link>
                  <p>View All</p>
                </div>
              </div>
              <small>Till Date</small>
            </div>

            <div className="expenses">
              <span className="material-symbols-outlined">
                group_add
              </span>
              <div className="middle">
                <div className="left">
                  <h3>Registered Students</h3>
                  <h1>{summaryData && summaryData.total_registered_students ? summaryData.total_registered_students : "Loading"}</h1>
                </div>
                <div className="dashboard-insights-progress">
                  <Link to='/dashboard/registerStudents'>
                    <p className="material-symbols-outlined view-all-dashboard-icon">
                      table_view
                    </p>
                  </Link>
                  <p>View All</p>
                </div>
              </div>
              <small>Till Date</small>
            </div>

            <div className="income">
              <span className="material-symbols-outlined">
                how_to_reg
              </span>
              <div className="middle">
                <div className="left">
                  <h3>Total Students Enrolled</h3>
                  <h1>{enrolledStudents.length}</h1> {/* Display the length of the enrolled students array */}
                </div>
                <div className="dashboard-insights-progress">
                  <Link to='/dashboard/enroled'>
                  <p className="material-symbols-outlined view-all-dashboard-icon">
                    table_view
                  </p>
                  </Link>
                  <p>View All</p>
                </div>
              </div>
              <small>Till Date</small>
            </div>
          </div>
        </div>
        <div className="charts-wrapper">
          <div className="chart chart-1" id="chart1">
            <DonutChart apiData={{ ...summaryData, total_enrolled_students: enrolledStudents.length }} />
          </div>
          <div className="chart chart-3" id="chart3">
            <LineChart apiData={{ ...summaryData, total_enrolled_students: enrolledStudents.length }} />
          </div>
        </div>
      </div>
    </>
  );
};

export default DefaultDashboard;
